import React, { useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { Client } from "../../../_models/Client.model";
import { ClientSearchAndFilter } from "../../../htmlComponents/clientSearchAndFilter";
import { useClientContext } from "../../../_context/ClientContext";
import { useCreateReportNotificationContext } from "../../../_context/CreateReportNotificationContext";
import { CreateReportAlerts } from "./CreateReportAlerts";
import { useSetReportAndClient } from "../../../_hooks/SetReportOnClients";
import { useReportContext } from "../../../_context/ReportContext";
import "../../Admin/AddUsers/AddUsers.css";
import "../Reports.css";

const LoadingSpinner = () => (
  <div className="rp-spinner-wrap">
    <svg className="rp-spinner" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563C0" strokeWidth="2.5" strokeLinecap="round">
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
    <span>Loading Clients...</span>
  </div>
);

export const CreateReportSelectClientLayout = () => {
  const [filteredClients, setFilteredClients] = useState<Client[]>([]);
  const [noDataOrLoadingData, setNoDataOrLoadingData] = useState<string>("");
  const { notification, displayNotification, setDisplayNotification } = useCreateReportNotificationContext();
  const { setClientForReporting } = useClientContext();
  const navigate = useNavigate();
  const setReportAndClient = useSetReportAndClient();
  const { setIsNewReport } = useReportContext();

  const handleClientReportSelect = (client: Client) => {
    setReportAndClient(client);
    setClientForReporting(client);
    setDisplayNotification(false);
    setIsNewReport(true);
    navigate("/reports/create_new_report");
  };

  return (
    <div className="reports-page-wrapper">
      <CreateReportAlerts
        alertMessage={notification}
        displayAlert={displayNotification}
        key="createReportAlert"
      />

      <div className="au-card" style={{ marginBottom: 24 }}>
        <div className="au-card-header">
          <div className="au-card-header-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" /><line x1="19" y1="8" x2="19" y2="14" /><line x1="22" y1="11" x2="16" y2="11" />
            </svg>
          </div>
          <div>
            <p className="au-card-header-title">Select Client for Report</p>
            <p className="au-card-header-sub">Search and choose a client to create a new assessment</p>
          </div>
        </div>


        <div className="au-card-body">
          <ClientSearchAndFilter
            setFiltererdClients={setFilteredClients}
            setDataStatus={setNoDataOrLoadingData}
          />

          {filteredClients.length > 0 ? (
            <div className="au-table-wrap" style={{ marginTop: 16 }}>
              <table className="au-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th style={{ width: "140px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredClients.map(client => client ? (
                    <tr key={client.Id}>
                      <td>{client.Name}</td>
                      <td style={{ color: "#6B7280" }}>{client.Email}</td>
                      <td>
                        <button
                          className="btn-action btn-primary w-100"
                          style={{ justifyContent: "center" }}
                          onClick={() => handleClientReportSelect(client)}
                        >
                          Select Client
                        </button>
                      </td>
                    </tr>
                  ) : null)}
                </tbody>
              </table>
            </div>
          ) : (
            noDataOrLoadingData === "Loading Clients" ? (
              <LoadingSpinner />
            ) : (
              <div className="au-empty">{noDataOrLoadingData}</div>
            )
          )}
        </div>
      </div>

      <Outlet />
    </div>
  );
};
